import $ from 'jquery';
import slick from 'slick-carousel';

var $slickElement = $('[data-slick]');
let slickElement = document.querySelectorAll( '[data-slick]' )
const slideServices = document.querySelectorAll( '.slide-services' )
const slideNavItem = document.querySelectorAll( '.slide-nav-item' )

if( $slickElement.length ) {
  slickElement.forEach( function( elem ) {

    // nav slider left
    $( elem ).parent().find( '.slick-prev' ).on( 'click' ,function(e) {
      e.preventDefault();
      $( elem ).slick('slickPrev');
    });

    // nav slider right
    $( elem ).parent().find( '.slick-next' ).on( 'click' ,function(e) {
      e.preventDefault();
      $( elem ).slick('slickNext');
    });

    // init slick
    $( elem ).slick({});

  } )

  // Toggle nav item active classes
  if( $( slideServices ).length ) {
    slideServices.forEach( ( elem ) => {
      $( elem ).on( 'afterChange', function( slick, currentSlide ) {
        $( '.slide-nav-item' ).removeClass( 'active' )
        slideNavItem.forEach( ( item ) => {
          if( currentSlide.currentSlide == $( item ).data( 'slide' ) ) {
            $( item ).addClass( 'active' );
          }
        } )
      } )
    } )
  }
}

// Services Nav
if( $( '.slide-nav' ).length ) {
  $( '.slide-nav > .slide-nav-item' ).click( function( e ) {
    $( '.slide-nav-item' ).removeClass( 'active' )
    $( this ).addClass( 'active' )

    $( '.slide-services' ).slick( 'slickGoTo', $( this ).data( 'slide' ));
  });
}

// helpers
function pad(n, width, z) {
  z = z || '0';
  n = n + '';
  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}